import {Depths, SharedColors} from "@fluentui/theme";
import {
    Callout,
    CommandBar,
    ICommandBarItemProps,
    Icon,
    Persona,
    PersonaSize,
    ProgressIndicator,
    Stack,
    Text,
} from "@fluentui/react";
import React, {FC, PropsWithChildren, useCallback, useContext, useEffect, useMemo, useState,} from "react";
import {useTranslation} from "react-i18next";
import {useLocation, useNavigate} from "react-router-dom";
import Axios from "axios";
import Cookies from "js-cookie";
import {matchPath} from "react-router";
import Color from "color";
import {AuthContext} from "../contexts/AuthContext";
import {LanguageContext} from "../contexts/LanguageContext";
import {OnixRoleEnum} from "../enums/OnixRoleEnum";
import {UserInfoHelper} from "../helpers/UserInfoHelper";
import {NavigationPanelContext} from "../state/State";
import {AppParts} from "../enums/AppParts";
import {
    MarservisLocalWorkOrderReturnDto,
    MarservisWorkOrderStatusEnum,
    PagedResult,
    SupportPriorityEnum,
    SupportTicketFilterTypeEnum,
    UnreadClientData,
} from "../API";
import {AppRoute, CompiledRoutes} from "../AppRoutes";
import {theme} from "../index";
import {MakeHub} from "../MakeHub";
import {UnreadMessagesCallout} from "./UnreadMessagesCallout";
import {SupportMessageColorHelper} from "../helpers/SupportMessageColorHelper";
import {iconDataFromPriority} from "./SupportPriorityIcon";
import {MainSearchBar} from "./MainSearchBar";
import "../styles/TopBar.css";
import {ApplicationPacketEnum} from "../graphql-types";
import {AxiosLoader} from "./AxiosLoader";
import TeamViewerMessageBarContext from "../contexts/TeamViewerMessageBarContext";
import md5 from "md5";
import {StringHelpers} from "../helpers/StringHelpers";
import {
    SUPPORT_TOP_BAR_FILTER_PARAM,
    serializeSupportTopBarFilter,
    supportTopBarFilterByCallout,
} from "../helpers/SupportTopBarFilterHelper";

export type calloutTypes =
    | "UnreadMessages"
    | "UnassignedTickets"
    | "UnfinishedTickets"
    | "DelegatedToMe"
    | "WaitingFor"
    | "UnfinishedTasks"
    | "UnfinishedProjects"
    | "EmergencyTickets"
    | "HighPriorityTickets"
    | "OldTickets";

const TopBar: FC<PropsWithChildren> = ({}) => {
    const {moment, serverDateToLocalDate} = useContext(LanguageContext);
    const navPanelOpen = useContext(NavigationPanelContext);
    const {UserInfo, SilentSetToken, SetToken} = useContext(AuthContext);
    const auth = useContext(AuthContext);
    const location = useLocation();
    const {i18n, t} = useTranslation();
    const {switchLanguage} = useContext(LanguageContext);
    const [showSupportPickerDialog, setShowSupportPickerDialog] = useState(false);
    const [unreadMessagesCount, setUnreadMessagesCount] =
        useState<UnreadClientData>();
    console.log(unreadMessagesCount);
    const [showingCallout, setShowingCallout] = useState<calloutTypes>();
    const [comingFromUser, setComingFromUser] = useState<string>();
    const [marservisWorkOrdersEnding, setMarservisWorkOrdersEnding] = useState<{
        endingSoon: number;
    }>();
    const [
        showMarservisWorkOrdersEndingSoon,
        setShowMarservisWorkOrdersEndingSoon,
    ] = useState<boolean>();
    const {setBottomMessageBarHidden, bottomMessageBarHidden} = useContext(
        TeamViewerMessageBarContext,
    );
    useEffect(() => {
        setComingFromUser(localStorage.getItem("coming_from_user") ?? "");
    }, []);
    const history = useNavigate();
    const openSupportCounter = useCallback(
        (calloutType: calloutTypes) => {
            const topBarFilter = supportTopBarFilterByCallout[calloutType] as
                | SupportTicketFilterTypeEnum
                | undefined;
            const openTicketList =
                UserInfo?.user?.supportTopBarCountersOpenTicketList !== false;

            if (topBarFilter != null && openTicketList) {
                history(
                    `${AppRoute.SUPPORT}?${SUPPORT_TOP_BAR_FILTER_PARAM}=${serializeSupportTopBarFilter(
                        topBarFilter,
                    )}`,
                );
                return;
            }

            setShowingCallout(calloutType);
        },
        [UserInfo, history],
    );
    const [activeTasks, setActiveTasks] = useState<{
        id: number;
        content: string;
        responsibleAgentId: string;
        companySettingsId: number;
        taskDue: Date;
        ticketId: number;
        companyName: string;
        taskStart: Date;
        type: "past" | "active" | "next";
    }>();
    const [totalTimeLogs, setTotalTimeLogs] = useState<number>(0);

    const companyName = "Onix informatika d.o.o.";
    const userName = "";
    let userDetail = "";

    if (UserInfo) {
        userDetail = UserInfo?.user?.userName ?? " - ";
    }

    const backToComingFromUser = useCallback(() => {
        if (comingFromUser) {
            localStorage.clear();
            Cookies.remove("access_token");
            Cookies.set("access_token", comingFromUser);
            localStorage.setItem("auth_token", comingFromUser!);
            setTimeout(() => {
                (window as any).location.href = "/dashboard";
            }, 1000);
        }
    }, [comingFromUser]);

    const switchToAlternativeUser = useCallback(
        (id?: string) => {
            Axios.get("Token/LoginAsAlternativeUser", {params: {id}}).then(
                ({data: {token}}) => {
                    SilentSetToken(token);
                },
            );
        },
        [UserInfo],
    );

    const data: ICommandBarItemProps[] = useMemo(() => {
        const items: ICommandBarItemProps[] = [
            {
                key: "hamburger",
                iconOnly: true,
                disabled: !UserInfo,
                iconProps: {
                    iconName: "CollapseMenu",
                },
                onClick: navPanelOpen.ToggleNavPanelVisible,
            },
            {
                iconOnly: true,
                key: "back",
                disabled: !UserInfo,
                iconProps: {
                    iconName: "ChevronLeftMed",
                },
                onClick: () => history(-1),
            },
        ];

        const path = location.pathname.split("/");

        let upto = "";
        let l = 0;

        const isOnixInfo =
            UserInfo?.user?.companySettings?.pantheonCompanyName ===
            "ONIX INFORMATIKA d.o.o.";

        for (const p of path) {
            upto += "/" + p;
            l += 1;
            if (p == "" && l == 1) {
                upto = "";
                items.push({
                    iconOnly: true,
                    key: "home",
                    disabled: !UserInfo,
                    iconProps: {
                        iconName: "Home",
                    },
                    onClick: () => history("/dashboard"),
                });
            } else {
                if (p != "") {
                    if (p == "edit" && path.length == l) {
                    } else {
                        const pt = upto + "";
                        let trans = t(p);
                        if (p == "support" && isOnixInfo) {
                            trans = "Grunf";
                        }

                        const exists = CompiledRoutes.find((path) =>
                            matchPath(path.routeValue, upto),
                        );

                        items.push({
                            key: p,
                            disabled: !exists || !UserInfo,
                            text: trans,
                            onClick: exists ? () => history(pt) : undefined,
                            className:
                                path.indexOf(p) == path.length - 1
                                    ? "active-top-bar-location"
                                    : "",
                        });
                    }
                }
            }
        }

        return items;
    }, [history, navPanelOpen, UserInfo]);

    const userIsAdmin = useMemo(
        () => UserInfoHelper.HasRole(OnixRoleEnum.ADMIN, UserInfo),
        [UserInfo],
    );

    const userHasSupport = useMemo(
        () => UserInfoHelper.HasPacket(UserInfo, ApplicationPacketEnum.Support),
        [UserInfo],
    );

    const hasMarservisWorkOrders = useMemo(
        () =>
            UserInfoHelper.HasPacket(
                UserInfo,
                ApplicationPacketEnum.MarservisWorkOrders,
            ),
        [UserInfo],
    );

    const getUnreadMessages = useCallback((unread: UnreadClientData) => {
        setUnreadMessagesCount(unread);
    }, []);

    useEffect(() => {
        if (userHasSupport) {
            const unreadHub = MakeHub(
                "UnreadSupportMessagesHub",
                "Changed",
                getUnreadMessages,
                null,
                true,
            );

            const totalTimeLogs = MakeHub(
                "TotalTimeLogsHub",
                "Changed",
                setTotalTimeLogs,
                undefined,
                true,
            );

            return () => {
                unreadHub.close();
                totalTimeLogs.close();
            };
        }
    }, [userHasSupport, getUnreadMessages, UserInfo, setTotalTimeLogs]);

    const getMarservisWorkOrdersEnding = useCallback(
        (ending: { endingSoon: number }) => {
            setMarservisWorkOrdersEnding(ending);
        },
        [],
    );

    useEffect(() => {
        if (hasMarservisWorkOrders) {
            const v = MakeHub(
                "UnreadMarservisWorkOrdersHub",
                "Changed",
                getMarservisWorkOrdersEnding,
                undefined,
                true,
            );
            return () => v.close();
        }
    }, [UserInfo, hasMarservisWorkOrders]);

    const commandBarItems: ICommandBarItemProps[] = useMemo(() => {
        let items: ICommandBarItemProps[] = [];

        if (userHasSupport) {
            if (bottomMessageBarHidden) {
                items.push({
                    key: "bottom-message-bar",
                    title: "Prikaži aktivnosti",
                    onClick: () => setBottomMessageBarHidden(false),
                    text: "Prikaži aktivnosti",
                    style: {
                        background: theme.palette.themePrimary,
                        color: "white",
                        marginRight: 5,
                    },
                });
            }
        }

        if (userHasSupport && unreadMessagesCount) {
            const dailyTicketDifference =
                unreadMessagesCount.dailyNewTickets -
                unreadMessagesCount.dailyResolvedTickets;
            const differenceIconName =
                dailyTicketDifference > 0
                    ? "CaretSolidUp"
                    : dailyTicketDifference < 0
                        ? "CaretSolidDown"
                        : "Remove";

            items.push({
                key: "DailyTicketCounters",
                title: `${t("new-ticket")}: ${unreadMessagesCount.dailyNewTickets}, ${t(
                    "Resolved",
                )}: ${unreadMessagesCount.dailyResolvedTickets}, ${t(
                    "unresolved",
                )}: ${unreadMessagesCount.dailyUnresolvedTickets}`,
                onClick: () => history(AppRoute.SUPPORT_DAILY_METRICS),
                onRender: () => (
                    <Stack
                        horizontal
                        verticalAlign="center"
                        tokens={{childrenGap: 6}}
                        className="ticket-daily-counter-command-bar-item has-clickable-action"
                        onClick={() => history(AppRoute.SUPPORT_DAILY_METRICS)}
                    >
                        <Stack
                            horizontal
                            verticalAlign="center"
                            tokens={{childrenGap: 4}}
                            className="ticket-daily-counter-pill ticket-daily-counter-pill-new"
                        >
                            <Icon iconName="Add"/>
                            <Text variant="small">{unreadMessagesCount.dailyNewTickets}</Text>
                        </Stack>
                        <Stack
                            horizontal
                            verticalAlign="center"
                            tokens={{childrenGap: 4}}
                            className="ticket-daily-counter-pill ticket-daily-counter-pill-resolved"
                        >
                            <Icon iconName="Accept"/>
                            <Text variant="small">
                                {unreadMessagesCount.dailyResolvedTickets}
                            </Text>
                        </Stack>
                        <Stack
                            horizontal
                            verticalAlign="center"
                            tokens={{childrenGap: 4}}
                            className="ticket-daily-counter-pill ticket-daily-counter-pill-unresolved"
                        >
                            <Icon iconName="Warning"/>
                            <Text variant="small">
                                {unreadMessagesCount.dailyUnresolvedTickets}
                            </Text>
                        </Stack>
                        <Stack
                            horizontal
                            verticalAlign="center"
                            tokens={{childrenGap: 4}}
                            className={`ticket-daily-counter-pill ${
                                dailyTicketDifference > 0
                                    ? "ticket-daily-counter-pill-diff-up"
                                    : dailyTicketDifference < 0
                                        ? "ticket-daily-counter-pill-diff-down"
                                        : "ticket-daily-counter-pill-diff-flat"
                            }`}
                        >
                            <Icon iconName={differenceIconName}/>
                            <Text variant="small">
                                {dailyTicketDifference > 0
                                    ? `+${dailyTicketDifference}`
                                    : `${dailyTicketDifference}`}
                            </Text>
                        </Stack>
                    </Stack>
                ),
            });

            if(unreadMessagesCount.emergencies) {
                items.push({
                    name: `HITNO ${unreadMessagesCount.emergencies}`,
                    title: t("EmergencyTickets"),
                    key: "EmergencyTickets",
                    className: "EmergencyTickets-command-bar-item",
                    iconProps: {
                        iconName: "WarningSolid",
                        id: "EmergencyTickets",
                        style: {
                            color: unreadMessagesCount.emergencies
                                ? SupportMessageColorHelper({
                                    isTask: true,
                                    isTaskDone: false,
                                } as any).originalMessageColor
                                : undefined,
                        },
                    },
                    disabled: !unreadMessagesCount.emergencies,
                    onClick: () => setShowingCallout("EmergencyTickets"),
                });
            }

            if (unreadMessagesCount.highPriority) {
                const highPriorityColor = iconDataFromPriority(
                    SupportPriorityEnum.High,
                ).color;

                items.push({
                    name: `${t("high-priority")} ${unreadMessagesCount.highPriority}`,
                    title: t("HighPriorityTickets"),
                    key: "HighPriorityTickets",
                    className: "HighPriorityTickets-command-bar-item",
                    iconProps: {
                        iconName: "Warning",
                        id: "HighPriorityTickets",
                        style: {
                            color: highPriorityColor,
                        },
                    },
                    disabled: !unreadMessagesCount.highPriority,
                    onClick: () => setShowingCallout("HighPriorityTickets"),
                });
            }

            if (unreadMessagesCount.oldTickets) {
                items.push({
                    name: `${t("old-tickets-short")} ${unreadMessagesCount.oldTickets}`,
                    title: t("OldTickets"),
                    key: "OldTickets",
                    className: "OldTickets-command-bar-item",
                    iconProps: {
                        iconName: "History",
                        id: "OldTickets",
                        style: {
                            color: SharedColors.orangeYellow20,
                        },
                    },
                    disabled: !unreadMessagesCount.oldTickets,
                    onClick: () => setShowingCallout("OldTickets"),
                });
            }

            items.push({
                name: `${unreadMessagesCount.unfinishedProjects}`,
                title: t("UnfinishedProjects"),
                key: "UnfinishedProjects",
                iconProps: {
                    iconName: "FabricFolderFill",
                    id: "UnfinishedProjects",
                    style: {
                        color: unreadMessagesCount.unfinishedProjects
                            ? SupportMessageColorHelper({
                                isTask: true,
                                isTaskDone: false,
                            } as any).originalMessageColor
                            : undefined,
                    },
                },
                disabled: !unreadMessagesCount.unfinishedProjects,
                onClick: () => setShowingCallout("UnfinishedProjects"),
            });

            items.push({
                name: `${unreadMessagesCount.unfinishedTasks}`,
                title: t("UnfinishedTasks"),
                key: "UnfinishedTasks",
                iconProps: {
                    iconName: unreadMessagesCount.unfinishedTasks ? "Cancel" : "Accept",
                    id: "UnfinishedTasks",
                    style: {
                        color: unreadMessagesCount.unfinishedTasks
                            ? SupportMessageColorHelper({
                                isTask: true,
                                isTaskDone: false,
                            } as any).originalMessageColor
                            : SupportMessageColorHelper({
                                isTask: true,
                                isTaskDone: true,
                            } as any).originalMessageColor,
                    },
                },
                disabled: !unreadMessagesCount.unfinishedTasks,
                onClick: () => openSupportCounter("UnfinishedTasks"),
            });

            items.push({
                name: `${unreadMessagesCount.delegatedToMe}`,
                title: t("DelegatedToMe"),
                key: "DelegatedToMe",
                iconProps: {
                    iconName: "MailAlert",
                    id: "DelegatedToMe",
                },
                disabled: !unreadMessagesCount.delegatedToMe,
                onClick: () => openSupportCounter("DelegatedToMe"),
            });

            items.push({
                name: `${unreadMessagesCount.waitingFor}`,
                title: t("WaitingFor"),
                key: "WaitingFor",
                iconProps: {
                    iconName: "MailSchedule",
                    id: "WaitingFor",
                },
                disabled: !unreadMessagesCount.waitingFor,
                onClick: () => openSupportCounter("WaitingFor"),
            });

            items.push({
                name: `${unreadMessagesCount.unread}`,
                title: t("UnreadMessages"),
                key: "UnreadMessages",
                iconProps: {
                    iconName: "Mail",
                    style: unreadMessagesCount.unread
                        ? {
                            color: "white",
                        }
                        : {},
                    id: "UnreadMessages",
                },
                style: unreadMessagesCount.unread
                    ? {
                        backgroundColor: theme.palette?.themePrimary,
                        color: "white",
                    }
                    : {},
                disabled: !unreadMessagesCount.unread,
                onClick: () => openSupportCounter("UnreadMessages"),
            });

            items.push({
                name: `${unreadMessagesCount.unfinished}`,
                title: t("UnfinishedTickets"),
                key: "UnfinishedTickets",
                iconProps: {
                    iconName: "MailUndelivered",
                    id: "UnfinishedTickets",
                },
                disabled: !unreadMessagesCount.unfinished,
                onClick: () => openSupportCounter("UnfinishedTickets"),
            });

            items.push({
                name: `${unreadMessagesCount.unassignedUnread}`,
                title: t("UnassignedTickets"),
                key: "UnassignedTickets",
                iconProps: {
                    iconName: "CreateMailRule",
                    id: "UnassignedTickets",
                    style: unreadMessagesCount.unassignedUnread
                        ? {
                            color: "white",
                        }
                        : {},
                },
                style: unreadMessagesCount.unassignedUnread
                    ? {
                        backgroundColor: SharedColors.red10,
                        color: "white",
                    }
                    : {},
                disabled: !unreadMessagesCount.unassignedUnread,
                onClick: () => openSupportCounter("UnassignedTickets"),
            });
        }

        items.push({
            name: "Search",
            title: t("search"),
            key: "search",
            onRender: (props) => <MainSearchBar/>,
        });

        // if (hasSupport.length) {
        //   items.push({
        //     name: t("manual"),
        //     title: t("manual"),
        //     key: "manual",
        //     iconProps: {
        //       iconName: "Help",
        //       id: AppParts.YOU_CAN_ALWAYS_RESTART_THIS_HELP,
        //       style: showingTutorial
        //         ? {
        //             color: "white",
        //           }
        //         : {},
        //     },
        //     style: showingTutorial
        //       ? {
        //           backgroundColor: theme.palette?.themePrimary,
        //           color: "white",
        //         }
        //       : {},
        //     disabled: !hasSupport.length,
        //     onClick: () => {
        //       if (hasSupport.length > 1) {
        //         setShowSupportPickerDialog(true);
        //       } else {
        //         tutorialPicked(hasSupport[0]);
        //       }
        //     },
        //   });
        // }

        if (hasMarservisWorkOrders && marservisWorkOrdersEnding?.endingSoon) {
            items.push({
                id: AppParts.MARSERVIS_WORKORDERS_ENDING_SOON,
                name: `${marservisWorkOrdersEnding?.endingSoon}`,
                title: `${marservisWorkOrdersEnding?.endingSoon}`,
                key: "marservis",
                iconProps: {
                    iconName: "EventDateMissed12",
                    style: marservisWorkOrdersEnding?.endingSoon
                        ? {
                            color: "white",
                        }
                        : {},
                },
                style: marservisWorkOrdersEnding?.endingSoon
                    ? {
                        backgroundColor: SharedColors.red10,
                        color: "white",
                    }
                    : {},
                disabled: !marservisWorkOrdersEnding?.endingSoon,
                onClick: () => {
                    setShowMarservisWorkOrdersEndingSoon(true);
                },
            });
        }

        const companyButton: ICommandBarItemProps = {
            key: "companyName",
            name: UserInfo?.user?.companySettings?.pantheonCompanyName ?? "",
        };

        if (UserInfo?.user?.alternativeUserId) {
            const alternatives: {
                id: string;
                companyName: string;
            }[] = [...[]];
            if (UserInfo.user.alternativeUserId) {
                alternatives.push({
                    id: UserInfo.user.alternativeUserId,
                    companyName: "Drugo poduzeće",
                });
            }

            companyButton.subMenuProps = {
                items: alternatives.map((m) => ({
                    onClick: () => switchToAlternativeUser(m.id),
                    iconProps: {
                        iconName: "CityNext",
                    },
                    text: m.companyName,
                    key: m.id!,
                })),
            };
        }

        items.push(companyButton);

        items = items.concat([
            {
                // name: userDetail,
                // title: userDetail,
                key: "user",
                disabled: !UserInfo,
                onRenderIcon: props => <Persona
                    imageInitials={StringHelpers.extractInitials(
                        userDetail
                    )}
                    text={userDetail}
                    size={PersonaSize.size28}
                    imageUrl={UserInfo?.user?.email ? "https://www.gravatar.com/avatar/" + md5(UserInfo?.user?.email) : undefined}
                />,
                subMenuProps: {
                    items: [
                        {
                            key: "userSettings",
                            name: t("user_settings"),
                            iconProps: {
                                iconName: "Settings",
                            },
                            onClick: () => history(AppRoute.SETTINGS),
                        },
                        {
                            key: "logout",
                            name: t("logout"),
                            iconProps: {
                                iconName: "SignOut",
                            },
                            onClick: () => {
                                sessionStorage.setItem("loggingOut", "true");
                                auth.Logout();
                            },
                        },
                    ].concat(
                        comingFromUser
                            ? [
                                {
                                    key: "backToCommingFromUser",
                                    name: t("return_to_main_user"),
                                    iconProps: {
                                        iconName: "SignOut",
                                    },
                                    onClick: backToComingFromUser,
                                },
                            ]
                            : [],
                    ),
                },
            },
        ]);

        return items;
    }, [
        userIsAdmin,
        t,
        unreadMessagesCount,
        UserInfo,
        hasMarservisWorkOrders,
        marservisWorkOrdersEnding,
        bottomMessageBarHidden,
        comingFromUser,
        openSupportCounter
    ]);

    const getPreferredScheme = useCallback<() => "dark" | "light">(
        () =>
            window?.matchMedia?.("(prefers-color-scheme:dark)")?.matches
                ? "dark"
                : "light",
        [],
    );

    const topBarColors = useMemo(() => {
        const colors = ["#32CD32", "#0000FF", "#FFD700", "#FF8C00", "#cd00cd"];
        return colors;
    }, []);

    // const totalTimeLogOverflows = useMemo(() => {
    //   const fullBarMinutes = 4 * 60;
    //   const halfBarMinutes = fullBarMinutes / 2;
    //   const totalBars = Math.floor((totalTimeLogs ?? 0) / fullBarMinutes);
    //   const remaining = (totalTimeLogs ?? 0) % fullBarMinutes;
    //   const bars = [];
    //   const isDark = getPreferredScheme() === "dark";
    //   const brightnessRate = isDark ? 0.1 : 0.15;
    //   const topBrightness = 0.4;
    //   let baseZIndex = 100000000;

    //   for (let i = 0; i < totalBars; i++) {
    //     const baseColor = Color(topBarColors[(2 * i + 1) % topBarColors.length]); // get the color for the second half of each bar
    //     const brightness = Math.min(topBrightness, i * brightnessRate);
    //     let hslValues = baseColor.hsl().array(); // Get the HSL values
    //     hslValues[2] = Math.min(100, hslValues[2] + brightness * 100); // Increase lightness by brightness
    //     const newColor = Color.hsl(...hslValues); // Create new color with increased lightness
    //     bars.push({
    //       percentComplete: 1,
    //       backgroundColor: baseColor.rgb().toString(),
    //       zIndex: baseZIndex + i,
    //     });
    //   }

    //   if (remaining > 0) {
    //     const half = Math.floor(remaining / halfBarMinutes);
    //     const baseColor = Color(topBarColors[(2 * totalBars + half) % topBarColors.length]);
    //     let hslValues = baseColor.hsl().array(); // Get the HSL values
    //     hslValues[2] = Math.min(100, hslValues[2] + ((remaining / halfBarMinutes - half) * topBrightness * 100)); // Increase lightness by brightness
    //     const newColor = Color.hsl(...hslValues); // Create new color with increased lightness
    //     bars.push({
    //       percentComplete: remaining / fullBarMinutes,
    //       backgroundColor: baseColor.rgb().toString(),
    //       zIndex: baseZIndex + totalBars + 10,
    //     });
    //   }

    //   return bars;
    // }, [totalTimeLogs, getPreferredScheme]);

    const expectedTotalTimeLogsTime = useMemo(() => 4 * 60, []); // in minutes

    const totalTimeLogOverflows = useMemo(() => {
        const overflows = Math.floor(
            (totalTimeLogs ?? 0) / expectedTotalTimeLogsTime,
        );
        const remaining = (totalTimeLogs ?? 0) % expectedTotalTimeLogsTime;
        const bars = [];
        const isDark = getPreferredScheme() === "dark";
        const brightnessRate = isDark ? 0.2 : 0.3;
        const topBrightness = 0.7;
        const baseZIndex = 100000000;
        const colors = [
            !isDark
                ? Color(theme.palette?.themePrimary)
                : Color(theme.palette?.themeDark),
            Color("#ff7b00"),
            Color("#00d800"),
            Color("#0000ff"),
            Color("#0000ff"),
            Color("#0000ff"),
            Color("#0000ff"),
        ];
        for (let i = 0; i < overflows; i++) {
            // const brightness = Math.min(topBrightness, i * brightnessRate);
            // const color = baseColor; // Convert your color to HSL
            // let hslValues = color.hsl().array(); // Get the HSL values
            // hslValues[2] = Math.min(100, hslValues[2] + brightness * 100); // Increase lightness by brightness
            // const newColor = Color.hsl(...hslValues); // Create new color with increased lightness
            const newColor = colors[i % colors.length];
            bars.push({
                percentComplete: 1,
                backgroundColor: newColor.rgb().toString(),
                zIndex: baseZIndex + i,
            });
        }
        if (remaining > 0) {
            // const brightness = Math.min(topBrightness, overflows * brightnessRate);
            // const color = Color("#ff6500"); // Convert your color to HSL
            // let hslValues = color.hsl().array(); // Get the HSL values
            // hslValues[2] = Math.min(100, hslValues[2] + brightness * 100); // Increase lightness by brightness
            // const newColor = Color.hsl(...hslValues); // Create new color with increased lightness
            const newColor = colors[overflows % colors.length];
            bars.push({
                percentComplete: remaining / expectedTotalTimeLogsTime,
                backgroundColor: newColor.rgb().toString(),
                zIndex: baseZIndex + overflows + 10,
            });
        }
        return bars;
    }, [expectedTotalTimeLogsTime, totalTimeLogs, getPreferredScheme]);

    return (
        <>
            {totalTimeLogOverflows.map((bar) => (
                <ProgressIndicator
                    key={bar.percentComplete}
                    percentComplete={bar.percentComplete}
                    barHeight={3}
                    styles={{
                        root: {
                            zIndex: 100000000,
                            position: "fixed",
                            top: 0,
                            left: 0,
                            right: 0,
                            padding: 0,
                            margin: 0,
                        },
                        progressBar: {
                            padding: 0,
                            backgroundColor: bar.backgroundColor,
                        },
                        progressTrack: {
                            padding: 0,
                            backgroundColor: "transparent",
                        },
                        itemProgress: {
                            padding: 0,
                        },
                    }}
                />
            ))}
            <CommandBar
                items={data}
                farItems={commandBarItems}
                style={{
                    position: "fixed",
                    width: "100vw",
                    backgroundColor: "white",
                    zIndex: 100,
                    boxShadow: Depths.depth4,
                }}
            />
            <UnreadMessagesCallout
                showingCallout={showingCallout}
                setShowingCallout={setShowingCallout}
            />
            {showMarservisWorkOrdersEndingSoon && (
                <Callout
                    onDismiss={() => setShowMarservisWorkOrdersEndingSoon(false)}
                    target={`#${AppParts.MARSERVIS_WORKORDERS_ENDING_SOON}`}
                >
                    <AxiosLoader<PagedResult<MarservisLocalWorkOrderReturnDto>>
                        method={Axios.post}
                        url="MarservisWorkOrders/List"
                        config={{
                            query: {
                                dateEnd: {
                                    LessThan: moment().add(5, "days").toISOString(),
                                },
                                status: {
                                    AnyOf: [
                                        MarservisWorkOrderStatusEnum.InProgress,
                                        MarservisWorkOrderStatusEnum.NotDone,
                                    ],
                                },
                            },
                            paging: {
                                count: 100,
                            },
                        }}
                    >
                        {(data, error) =>
                            error ? (
                                <Stack tokens={{padding: 10}}>
                                    <Text>{t("there_was_an_error")}</Text>
                                </Stack>
                            ) : data ? (
                                <Stack tokens={{}}>
                                    <Stack tokens={{padding: 10}}>
                                        <Text>{t("marservis_workorders_ending_soon")}</Text>
                                    </Stack>
                                    <Stack>
                                        {data.items.map((item) => {
                                            const endsSoon =
                                                item.dateEnd &&
                                                moment(item.dateEnd).diff(moment(), "days") < 5;
                                            const ended =
                                                item.dateEnd &&
                                                moment(item.dateEnd).diff(moment(), "days") < 0;

                                            return (
                                                <Stack
                                                    onClick={() => {
                                                        setShowMarservisWorkOrdersEndingSoon(false);
                                                        history(
                                                            AppRoute.MARSERVIS_WORK_ORDER_ITEMS(item.id),
                                                        );
                                                    }}
                                                    className="has-clickable-action"
                                                    style={{}}
                                                    tokens={{padding: 10}}
                                                    horizontal
                                                    horizontalAlign="space-between"
                                                    verticalAlign="center"
                                                >
                                                    <Stack>
                                                        <Text>{item.id}</Text>
                                                        <Text
                                                            style={
                                                                ended
                                                                    ? {
                                                                        color: SharedColors.red10,
                                                                        fontWeight: "bold",
                                                                    }
                                                                    : endsSoon
                                                                        ? {
                                                                            color: SharedColors.orange10,
                                                                            fontWeight: "bold",
                                                                        }
                                                                        : {}
                                                            }
                                                            key={item.id}
                                                        >
                                                            {serverDateToLocalDate(item.dateEnd).format("L")}
                                                        </Text>
                                                    </Stack>
                                                    <div style={{width: 10}}/>
                                                    <Stack
                                                        horizontalAlign="end"
                                                        horizontal
                                                        verticalAlign="center"
                                                    >
                                                        <Stack horizontalAlign="end">
                                                            <Text>{item.project?.name ?? " - "}</Text>
                                                            <Text variant="xSmall">
                                                                {item.project?.subject?.shortName ?? " - "}
                                                            </Text>
                                                        </Stack>
                                                        <div style={{width: 10}}/>
                                                        <Icon iconName="ChevronRight"/>
                                                    </Stack>
                                                </Stack>
                                            );
                                        })}
                                    </Stack>
                                </Stack>
                            ) : (
                                <Stack tokens={{padding: 10}}>
                                    <Text>{t("loading")}</Text>
                                </Stack>
                            )
                        }
                    </AxiosLoader>
                </Callout>
            )}
        </>
    );
};

export default TopBar;
